import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import getRelativeUrl from 'utils/getRelativeUrl'

import { media } from 'styled-bootstrap-grid'
import styled from 'styled-components'
import theme from 'ui/styles/theme'

const TextContainer = styled.div`
  position: relative;
  height: 100%;
  align-items: center;
  display: flex;
  background: ${theme.colors.accents.secondary};
`

const Heading = styled.p`
  color: ${theme.colors.tones.darker};
  font-size: 20px;
  font-weight: 300;
  left: 25px;
  position: absolute;
  top: 22px;
  z-index: 2;
`

const Overlay = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 1;
  background: ${props => props.overlayColor ? props.overlayColor : theme.colors.tones.lighter};
  opacity: ${props => props.overlayOpacity};
  pointer-events: none;
`

const Paragraph = styled.p`
  font-size: 16px;
  line-height: 20px;
  color: ${theme.colors.primary};
  padding: 75px 25px 25px;
  margin: 0;

  ${media.sm`
    padding: 0 25px;
  `}
`

export default class Text extends Component {
  static propTypes = {
    heading: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired,
    text: PropTypes.string,
    overlayColor: PropTypes.string,
    overlayOpacity: PropTypes.number
  }
  
  static defaultProps = {
    overlayColor: null,
    overlayOpacity: null,
    text: null
  }
  
  render() {
    const {
      heading,
      link,
      overlayColor,
      overlayOpacity,
      text,
      externalLink
    } = this.props

    if(externalLink) {
      return (
        <a href={link} target="_blank">
          <TextContainer>
            <Heading>{heading}</Heading>
            <Overlay
              overlayColor={overlayColor}
              overlayOpacity={overlayOpacity}
            />
            <Paragraph>{text}</Paragraph>
          </TextContainer>
        </a>
      )
    } else {
      return (
        <Link to={getRelativeUrl(link)}>
          <TextContainer>
            <Heading>{heading}</Heading>
            <Overlay
              overlayColor={overlayColor}
              overlayOpacity={overlayOpacity}
            />
            <Paragraph>{text}</Paragraph>
          </TextContainer>
        </Link>
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/ui/components/modules/Hero/Text.js